(() => {
  const mount = (root) => {
    if (!root || root.dataset.v4Mounted) return;
    root.dataset.v4Mounted = 'true';
    const video = root.querySelector('[data-v4-hero-video]');
    const gallery = root.querySelector('[data-v4-gallery]');
    if (video && gallery) {
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      const stage = gallery.querySelector('[data-gallery-stage]');
      const caption = gallery.querySelector('[data-gallery-current-caption]');
      const count = gallery.querySelector('[data-gallery-count]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const dialog = root.querySelector('[data-studio-dialog]');
      let active = 0;
      let autoplayAttempted = false;
      const show = (index, playVideo = false) => {
        autoplayAttempted = true;
        video.pause();
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== active; });
        thumbs.forEach((thumb, i) => { thumb.setAttribute('aria-pressed', String(i === active)); });
        caption.textContent = slides[active].dataset.galleryCaption;
        count.textContent = `${active + 1} / ${slides.length}`;
        if (active === 0 && playVideo) {
          video.currentTime = 0;
          video.play().catch(() => {});
        }
      };
      count.textContent = `1 / ${slides.length}`;
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i, true)));
      gallery.querySelector('[data-gallery-prev]').addEventListener('click', () => show(active - 1, true));
      gallery.querySelector('[data-gallery-next]').addEventListener('click', () => show(active + 1, true));
      gallery.querySelector('[data-gallery-thumbs]').addEventListener('keydown', (event) => {
        const index = thumbs.indexOf(event.target.closest('[data-gallery-thumb]'));
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % thumbs.length;
        if (event.key === 'ArrowLeft') next = (index + thumbs.length - 1) % thumbs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = thumbs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        show(next, true);
        thumbs[next].focus({preventScroll: true});
      });
      video.addEventListener('play', () => {
        const firstPhoto = slides[1]?.querySelector('img');
        if (firstPhoto) firstPhoto.loading = 'eager';
      });
      video.addEventListener('ended', () => {
        if (active !== 0 || slides.length < 2) return;
        const moveFocus = document.activeElement === video;
        show(1);
        if (moveFocus) thumbs[1].focus({preventScroll: true});
      });
      let touchStart;
      stage.addEventListener('touchstart', (event) => {
        touchStart = active > 0 && event.touches.length === 1
          ? {x: event.touches[0].clientX, y: event.touches[0].clientY}
          : null;
      }, {passive: true});
      stage.addEventListener('touchend', (event) => {
        if (!touchStart || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - touchStart.x;
        const dy = event.changedTouches[0].clientY - touchStart.y;
        touchStart = null;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) show(active + (dx < 0 ? 1 : -1), true);
      }, {passive: true});
      new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.3) {
          video.pause();
        } else if (active === 0 && !autoplayAttempted && !reducedMotion.matches && !navigator.connection?.saveData && !document.hidden && !dialog?.open) {
          autoplayAttempted = true;
          video.play().catch(() => {});
        }
      }, {threshold: [0, 0.3]}).observe(stage);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
      });
      reducedMotion.addEventListener('change', () => {
        if (reducedMotion.matches) video.pause();
      });
      if (dialog) new MutationObserver(() => {
        if (dialog.open) video.pause();
      }).observe(dialog, {attributes: true, attributeFilter: ['open']});
    }
    const range = root.querySelector('[data-v4-reveal]');
    range?.addEventListener('input', () => {
      root.querySelector('[data-v4-compare]').style.setProperty('--reveal', `${range.value}%`);
      range.removeAttribute('aria-valuetext');
    });
    const mirror = () => {
      root.querySelectorAll('[data-v4-mirror]').forEach((target) => {
        const source = root.querySelector(`[data-${target.dataset.v4Mirror}]`);
        if (source && source.textContent !== target.textContent) target.textContent = source.textContent;
      });
      const dhl = root.querySelector('[data-v4-dhl]');
      const source = root.querySelector('[data-express-delivery]');
      if (dhl) dhl.hidden = !source || source.hidden;
    };
    const delivery = root.querySelector('[data-delivery]');
    if (delivery) {
      new MutationObserver(mirror).observe(delivery, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['hidden']});
      mirror();
    }
    const sticky = root.querySelector('[data-v4-sticky]');
    const intro = root.querySelector('.pbd-v4__hero');
    if (sticky && intro) {
      let pastHero = false;
      const update = () => { sticky.hidden = !pastHero || !!root.querySelector('dialog[open]'); };
      new IntersectionObserver(([entry]) => {
        pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        update();
      }).observe(intro);
      const dialog = root.querySelector('[data-studio-dialog]');
      if (dialog) new MutationObserver(update).observe(dialog, {attributes:true,attributeFilter:['open']});
    }
  };
  document.querySelectorAll('.pbd-v4').forEach(mount);
  document.addEventListener('shopify:section:load', (event) => mount(event.target.querySelector('.pbd-v4')));
})();


